// extracted by mini-css-extract-plugin
export var button = "notFound-module--button--01db4";
export var cafeFormIntro = "notFound-module--cafe-form-intro--8098a";
export var desc = "notFound-module--desc--5a3df";
export var highlight = "notFound-module--highlight--dcb1f";
export var redButton = "notFound-module--red-button--96341";
export var redTransparentButton = "notFound-module--red-transparent-button--d3e9c";
export var title = "notFound-module--title--413f2";
export var transparentButton = "notFound-module--transparent-button--99fe5";